import {
	applyForm1State,
	applyForm2State,
	applyForm3State,
	registCompanyFormState,
	signupFormState,
} from "@src/state/client";
import { useResetRecoilState } from "recoil";

export function useResetApplyForm() {
	const resetRegistCompanyFormState = useResetRecoilState(registCompanyFormState);
	const resetApplyForm1State = useResetRecoilState(applyForm1State);
	const resetApplyForm2State = useResetRecoilState(applyForm2State);
	const resetApplyForm3State = useResetRecoilState(applyForm3State);
	const resetSignupFormState = useResetRecoilState(signupFormState);

	const handleResetApplyForm = () => {
		resetRegistCompanyFormState();
		resetApplyForm1State();
		resetApplyForm2State();
		resetApplyForm3State();
		resetSignupFormState();
	};
	return {
		handleResetApplyForm,
	};
}
